import { currentUserShowSuccess } from '../../ducks/user.duck';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const TOGGLE_HOLIDAY_MODE_REQUEST = 'app/HolidayModePage/TOGGLE_HOLIDAY_MODE_REQUEST';
export const TOGGLE_HOLIDAY_MODE_SUCCESS = 'app/HolidayModePage/TOGGLE_HOLIDAY_MODE_SUCCESS';
export const TOGGLE_HOLIDAY_MODE_ERROR = 'app/HolidayModePage/TOGGLE_HOLIDAY_MODE_ERROR';

// ================ Reducer ================ //

const initialState = {
  toggleHolidayModeError: null,
  toggleHolidayModeInProgress: false,
  toggleHolidayModeSuccess: false,
};

export default function reducer(state = initialState, { type, payload } = {}) {
  switch (type) {
    case TOGGLE_HOLIDAY_MODE_REQUEST:
      return {
        ...state,
        toggleHolidayModeInProgress: true,
        toggleHolidayModeError: null,
        toggleHolidayModeSuccess: false,
      };
    case TOGGLE_HOLIDAY_MODE_SUCCESS:
      return {
        ...state,
        toggleHolidayModeInProgress: false,
        toggleHolidayModeSuccess: true,
      };
    case TOGGLE_HOLIDAY_MODE_ERROR:
      return {
        ...state,
        toggleHolidayModeInProgress: false,
        toggleHolidayModeError: payload,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const toggleHolidayModeRequest = () => ({
  type: TOGGLE_HOLIDAY_MODE_REQUEST,
});

export const toggleHolidayModeSuccess = () => ({
  type: TOGGLE_HOLIDAY_MODE_SUCCESS,
});

export const toggleHolidayModeError = error => ({
  type: TOGGLE_HOLIDAY_MODE_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const toggleHolidayMode = () => async (dispatch, getState, sdk) => {
  dispatch(toggleHolidayModeRequest());

  const { currentUser } = getState().user;
  const { isHolidayMode } = currentUser.attributes.profile.publicData || {};

  try {
    const response = await sdk.currentUser.updateProfile(
      {
        publicData: {
          isHolidayMode: !isHolidayMode,
        },
      },
      { expand: true }
    );

    const [updatedUser] = denormalisedResponseEntities(response);

    if (!updatedUser) {
      throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
    }

    dispatch(currentUserShowSuccess(updatedUser));
    dispatch(toggleHolidayModeSuccess());
  } catch (e) {
    dispatch(toggleHolidayModeError(storableError(e)));
    throw e;
  }
};
